exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-replate-js": () => import("./../../../src/pages/replate.js" /* webpackChunkName: "component---src-pages-replate-js" */),
  "component---src-pages-sfai-js": () => import("./../../../src/pages/sfai.js" /* webpackChunkName: "component---src-pages-sfai-js" */),
  "component---src-pages-toybox-js": () => import("./../../../src/pages/toybox.js" /* webpackChunkName: "component---src-pages-toybox-js" */)
}

